import { useSelector } from 'react-redux'
import { selectDisplayProductsMode } from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'
import { DisplayProductsMode } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'
import { PlanTableDataPlainList } from './PlanTableDataPlainList'
import { PlanTableDataCategories } from './PlanTableDataCategories'

const PlanTableData = () => {
  const displayProductsMode = useSelector(selectDisplayProductsMode)

  return displayProductsMode === DisplayProductsMode.categories ? (
    <PlanTableDataCategories />
  ) : (
    <PlanTableDataPlainList />
  )
}

export default PlanTableData
